import React from 'react';

/*eslint-disable */

var chevronRightWithCircleIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-826.000000, -245.000000)",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(836.000000, 255.000000) rotate(0.000000) translate(-836.000000, -255.000000) translate(826.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,2 C14.4,2 18,5.6 18,10 C18,14.4 14.4,18 10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 L10,2 Z M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 L10,0 Z",
    className: "manulifeIconSecondary-fill"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13 9.6 13.5 10.1 12.8 10.8 12.8 10.8 9.4 14 8 12.6 10.6 10 8 7.4 9.4 6 13 9.6"
  }))))));
});

export default chevronRightWithCircleIcon;
